import { Component, ViewChild, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { AutoCompleteKeyUpObj } from "@app/definitions/types"
import { GenAutocompleteComponent } from "@app/gen-inputs/gen-autocomplete/gen-autocomplete.component"
import { Modalable } from "@app/Modalable"
import { environment } from "@env/environment"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { GenFileInputComponent } from "@app/gen-inputs/gen-file-input/gen-file-input.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { DatePickerComponent } from "@app/utils/date-picker/date-picker.component"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { BtnExtComponent, CancelBtnComponent } from "@app/utils/utils.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { GenTableAddItemComponent } from "@app/gen-table-add-item/gen-table-add-item.component"

@Component({
	selector: "app-upload-prediction-file",
	imports: [
		COMMON_IMPORTS,
		GenInputComponent,
		GenFileInputComponent,
		LangValPipe,
		GenAutocompleteComponent,
		DatePickerComponent,
		GenButtonGroupComponent,
		CancelBtnComponent,
		BtnExtComponent,
		ModalWrapComponent,
		GenTableAddItemComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./upload-prediction-file.component.html",
})
export class UploadPredictionFileComponent extends Modalable {
	modalProps: any = null
	@ViewChild("expensetypeInput") expensetypeInput: GenAutocompleteComponent
	@ViewChild("supplierInput") supplierInput: GenAutocompleteComponent
	@ViewChild("fileInput") fileInput: GenFileInputComponent

	modalTitleLang: string = "scan_expense"
	modalWidth: string = "modal-800"
	document: any = null
	isUploading: boolean = false
	isSaving: boolean = false
	url: string = ""
	sendObj: any = null
	errors: any = {}
	isFormSubmittable: boolean = false
	validationFields: any = {
		description: { not_empty: null },
		date: { not_empty: null },
		sum: { not_empty: null },
		expensetype_id: { is_legit_fuzzy_value: null },
	}
	fileName: string = ""

	ngAfterViewInit() {
		this.fileInput?.elementEl?.nativeElement?.click()
	}

	async uplFile(files: FileList) {
		this.document = files ? files.item(0) : null
		if (!this.document) {
			return
		}
		this.isUploading = true
		const res: any = await this.apiService.upload("upload_prediction_file", {
			document: this.document,
		})
		this.document = null
		this.isUploading = false
		this.modalService.openToast(
			res.success ? "uploaded_succesfully" : "upload_failed"
		)

		if (!res.success) {
			return
		}
		this.sendObj = {
			expensetype_id: null,
			supplier_id: 0,
			description: res?.supplier_name || "",
			supplier_invoice: res?.supplier_invoice || "",
			israel_invoice: res?.israel_invoice || "",
			date: res?.date || "",
			sum: res?.sum || "",
			withvat: res?.withvat || "",
		}
		this.fileName = res.file
		setTimeout(() => {
			this.checkForSupplier(res?.supplier_name)
		}, 50)
	}
	checkForSupplier(name: string) {
		const obj = this.store
			.getSiteDataTable("suppliers")
			.find((it) => it.name == name)
		if (obj) {
			this.chooseSupplier(obj)
		} else {
			this.supplierInput.onkeyup(name)
		}
	}
	getUrl() {
		return `${environment.serverUrl}/expense-file-img?file=${this.fileName}`
	}
	validateEntireForm() {
		this.isFormSubmittable = this.validator.validateEntireForm(
			this.sendObj,
			this.errors,
			this.validationFields
		)
	}
	handleKeyUp(obj: AutoCompleteKeyUpObj, fieldName: string) {
		if (!obj.isIdenticalToPreviousValue) {
			this.sendObj[fieldName] = null
			this.validateEntireForm()
		}
	}
	async submit() {
		this.isSaving = true
		const res = await this.apiService.post("approve_expense_file", {
			...this.sendObj,
			fileName: this.fileName,
		})
		this.modalService.openToast(res?.id ? "saved_successfully" : "save_failed")

		this.isSaving = false
		if (!res?.id) {
			return
		}
		this.sendObj = null
		this.store.addGenItemRow("expenses", res)
		this.store.refreshTableSubject.next("expenses")
		this.onClose.emit()
	}
	openAddExpensetypeModal() {
		this.modalProps = {
			name: "add-expensetype",
			fuzzyName: this.expensetypeInput.returnSearchStrForAdding(),
		}
	}
	chooseExpensetype(obj: any) {
		this.sendObj.expensetype_id = obj.id
		this.expensetypeInput.searchStr = obj.name
		this.validateEntireForm()
	}
	async openAddSupplierModal() {
		this.modalProps = {
			name: "add-supplier",
			fuzzyName: this.supplierInput.returnSearchStrForAdding(),
		}
	}
	handleSupplierChanged() {
		const obj = this.store.searchSiteDataItem(this.sendObj.supplier_id, [
			"suppliers",
		])
		if (obj?.expensetype_id) {
			const expensetype = this.store.searchSiteDataItem(obj.expensetype_id, [
				"expensetypes",
			])
			if (expensetype) {
				this.chooseExpensetype(expensetype)
			}
		}
		this.validateEntireForm()
	}
	chooseSupplier(obj: any) {
		this.sendObj.supplier_id = obj.id
		this.supplierInput.searchStr = obj.name
		this.handleSupplierChanged()
	}
}
